import Vue from 'vue'
import Router from 'vue-router'
import { store } from './store.js'
// import evaluaties from '../pages/Evaluaties.vue'

import evalroutes from './router/evalroutes.js'
import mainroutes from './router/mainroutes.js'
import testroutes from './router/testroutes.js'
let routeFiles = []

Vue.use(Router)
const routes = routeFiles.concat(evalroutes, testroutes, mainroutes)
export const router = new Router({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('/peapp/') !== -1) {
    store.commit('startLoading', { showmessage: false, disablepage: false })
  }
  if (to.matched.some(record => record.meta.BodyScroll === false)) {
    window.scrollTo(0, 1)
    document.querySelectorAll('body')[0].style.overflow = 'hidden'
  } else {
    document.querySelectorAll('body')[0].style.overflow = 'initial'
  }
  setTimeout(() => {
    next() // next moet gezet worden anders stopt de navigatie, timeout omdat anders de css fadeout animatie nog niet gestart is
  }, 100)
})
